import { StyleSheet } from 'aphrodite';
import { THEME } from '../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		marginTop: THEME.spacing.sm,
	},
	label: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	names: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
});
